<template>
  <div class="TableBase">
    <v-card dense v-if="search!=''">
      <v-layout align-center justify-space-between row v-if="modo==='Reporte Medico'">
        <v-flex xs6>
          <v-layout row wrap>
            <v-flex xs1>
              <v-icon
                x-large
                color="blue darken-4"
              >
                assignment_ind
              </v-icon>
            </v-flex>
            <v-flex xs8>
              <h3> Nombre Supervisor: {{supervisorName}} </h3>
              <h4> Empresa: {{supervisorEmpresa}} </h4>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex grow xs6>
          <v-div class="right">
            <v-icon
              @click="search=''"
              color="red"
              medium
            >
              clear
            </v-icon>
          </v-div>
        </v-flex>
      </v-layout>
     </v-card>
    <br>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"

      :pagination.sync ="propiedades_table"

    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            width="1%"
            @click="changeSort(header.value)"
            :class="['column sortable', propiedades_table.descending ? 'desc' : 'asc', header.value === propiedades_table.sortBy ? 'active' : '']"
          >
            <v-layout row wrap>
              <v-flex xs10>
                <template v-if="header.text ==='Se ha saltado comidas'">
                  <p>Se ha saltado<br>comidas</p>
                </template>
                <template v-else-if="header.text ==='Probabilidad de tener Covid'">
                  <p>Probabilidad<br>de tener covid</p>
                </template>
                  <template v-else-if="header.text ==='Teléfono Personal'">
                  <p>Teléfono<br>Personal</p>
                </template>
                <template v-else-if="header.text ==='Teléfono Móvil Supervisor'">
                  <p>Teléfono<br>Supervisor</p>
                </template>
                <template v-else-if="header.text ==='Contacto cercano Covid'">
                  <p>Contacto<br>cercano Covid</p>
                </template>
                <template v-else-if="header.text ==='Riesgo de Contagiarse'">
                  <p>Riesgo de<br>contagiarse</p>
                </template>
                <template v-else-if="header.text ==='Dolor de garganta'">
                  <p >Dolor de<br>Garganta</p>
                </template>
                <template v-else-if="header.text ==='Presencia casos de COVID'">
                  <p >Presencia<br>casos de COVID</p>
                </template>
                <template v-else>
                  {{ header.text }}
                </template>

              </v-flex>
              <v-flex xs2>
               <v-icon small>arrow_upward</v-icon>
              </v-flex>
            </v-layout>

          </th>
        </tr>

      </template>

      <template slot="items" slot-scope="props">

        <td
          v-for="col in columns"
          :key="col.id"
          :align="align(props.item[col])"

        >
        <template v-if="props.item[col] != null">
            <template v-if="(props.item[col])==='Sí'">
              <h1 class="red--text text--darken-3">SI</h1>
            </template>
            <template v-else-if="col==='Teléfono Móvil Supervisor'">
              <a v-on:click="searchSupervisor(props.item[col])"
                class="blue--text text--darken-4">
                <h4>{{ props.item[col] }}</h4>
              </a>
            </template>
            <template v-else-if="col==='cc'">
              <a v-on:click="openLink(props.item.cc)" class="green--text text--darken-2">
                <h4>{{ props.item[col] }}</h4>
              </a>
            </template>
            <template v-else-if="col==='Temperatura'">
              <template v-if="(props.item[col])>37.5">
                <h3 class="red--text text--darken-3">{{ props.item[col] }}</h3>
              </template>
              <template v-else>
                {{ props.item[col] }}
              </template>
            </template>
            <template v-else-if="col==='Oximetria'">
              <template v-if="(props.item[col])<90">
                <h3 class="red--text text--darken-3">{{ props.item[col] }}</h3>
              </template>
              <template v-else>
                {{ props.item[col] }}
              </template>
            </template>
            <template v-else>
            {{ props.item[col] }}
            </template>
        </template>
        <template v-else>
          No disponible
        </template>
        </td>

        <td class="text-xs-right">
          <template v-if="modo==='Reporte Medico'">
            <v-icon
              color="green darken-4"
              class="mr-1"
              large
              @click="openLink(props.item.cc)"
            >
              assignment
            </v-icon>
          </template>

          <template v-else>
            <v-icon
              color="blue darken-4"
              class="mr-1"
              large
              @click="getEvolucion(props.item.Fecha)"
            >
              pending_actions
            </v-icon>
          </template>
         </td>

      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog_historia_clinica"
      width="700"
      >
      <v-card color="#311B92" >
        <v-card-title primary-title>
          <h1 class="white--text text-md-center text-lg-center">Notas médicas del dia {{fecha}}</h1>
          <v-icon color="white" large right>assignment_ind</v-icon>
        </v-card-title>
        <v-card-text v-if="cargando_evaluacion" class="white--text">
          <v-progress-linear :indeterminate="true" color="#32a8f0"></v-progress-linear>

        </v-card-text>
        <v-card-text  v-else-if="sin_evaluacion">
          <p class="white--text">No se encontraron resultados</p>

        </v-card-text>

        <v-card-text v-else>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 v-for="n in evaluaciones" :key="n.id">

                <v-card
                    elevation-19
                    hover
                    color="white"
                    light
                  >
                  <v-layout v-layout align-center justify-space-between row fill-height>
                    <v-flex xs4 pa-3>
                      <v-text-field
                        v-model="n.medico"
                        append-icon="account_circle"
                        type="text"
                        name="input-10-1"
                        label="Médico"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <p class="blue--text headline">Hora: {{n.fecha}}</p>
                    </v-flex>
                  </v-layout>

                  <v-layout align-center column >
                    <v-layout align-space-between justify-center row pa-2>
                      <v-flex md4>
                        <v-textarea
                          v-model="n.h_clinica_paciente"
                          rows = "1"
                          box
                          name="input-7-4"
                          label="Paciente"
                          readonly
                        ></v-textarea>
                      </v-flex>

                      <v-flex md4>
                        <v-textarea
                          v-model="n.h_clinica_idx"
                          rows = "1"
                          box
                          name="input-7-5"
                          label="Idx"
                          readonly
                        ></v-textarea>
                      </v-flex>

                      <v-flex md4>
                        <v-textarea
                          rows = "1"
                          box
                          name="input-7-6"
                          label="Rx"
                          v-model="n.h_clinica_rx"
                          readonly
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-layout >
                </v-card>
                <br>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TableBaseCovid',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Desarrolla la busqueda dentro de la tabla */
    search: {
      type: String,
      required: false
    },
    modo: {
      type: String,
      required: false
    },
    cedula: {
      type: String,
      required: false
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      // search: '',
      propiedades_table: {
        descending: true,
        page: 1,
        rowsPerPage: 25, // -1 for All",
        sortBy: 'Fecha',
        width: '50%'
        // totalItems: number"
      },

      backConf: {
        pathSupervisor: '/projects/covid/supervisor/',
        pathEvolucion: '/projects/covid/evoluciones/',
        page: 1
      },

      supervisorName: null,
      supervisorEmpresa: null,

      dialog_historia_clinica: false,
      h_clinica_paciente: null,
      h_clinica_idx: null,
      h_clinica_rx: null,
      fecha: null,

      evaluaciones: [],
      cargando_evaluacion: true,
      sin_evaluacion: false,
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []

      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      let type = typeof val

      switch (type) {
        case 'string':
          if (val[val.length - 1] === '%' || val[val.length - 2] === '.') {
            algn = 'center'
          } else {
            algn = 'center'
          }
          break
        case 'number':
          algn = 'left'
          break
        default:
          algn = 'center'
      }

      return algn
    },

    /**
     * funcion para Abrir en una pestaña nueva
     * La ficha Personal del reporte medico
     * @param  {string} c cedula de la ficha personal
     */
    openLink (c) {
      this.$router.push({
        name: 'FichaPersonal',
        params: {
          cc: c
        }
      })
    },

    searchSupervisor (c) {
      this.search = c
      this.supervisorName = null
      this.supervisorEmpresa = null

      let request = {
        method: 'get',
        url: this.backConf.pathSupervisor,
        params: {
          operativo: this.operativo,
          supervisor: c

        }
      }

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          // console.log(resp.data)
          t.supervisorName = (resp.data.Nombre)
          t.supervisorEmpresa = (resp.data.Empresa)
        })
        .catch(err => console.error(err))
    },

    getEvolucion (fecha) {
      this.dialog_historia_clinica = true
      fecha = fecha.substring(0, 10)
      this.evaluaciones = []
      this.cargando_evaluacion = true
      let request = {
        method: 'get',
        url: this.backConf.pathEvolucion,
        params: {
          op: this.operativo,
          fecha: fecha,
          paciente: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          let data = resp.data.results
          let arr = []

          if (resp.data.count > 0) {
            console.log('hola')
            for (const e in data) {
              let dicc = {
                'id': e,
                'h_clinica_paciente': data[e].cuadro_clinico,
                'h_clinica_idx': data[e].impresion,
                'h_clinica_rx': data[e].recomendaciones,
                'fecha': data[e].fecha.substr(11, 8),
                'medico': data[e].usuario
              }
              arr.push(dicc)
            }

            t.evaluaciones = arr
            t.cargando_evaluacion = false
          } else {
            console.log('hola2')
            t.cargando_evaluacion = false
            t.sin_evaluacion = true
          }
        })
        .catch(err => console.error(err))
    },
    changeSort (column) {
      if (this.propiedades_table.sortBy === column) {
        this.propiedades_table.descending = !this.propiedades_table.descending
      } else {
        this.propiedades_table.sortBy = column
        this.propiedades_table.descending = false
      }
    }
  }
}
</script>
